<template lang="pug">
  transition(name='error')
    .error-alert(v-show="showGlobalNotification")
      .alert(role='alert' :class="`alert-${globalNotificationType}`") {{ globalNotificationMessage }}
</template>

<script>
import { mapFields } from 'vuex-map-fields'
export default {
  name: 'GlobalNotification',
  computed: {
    ...mapFields([
      'showGlobalNotification',
      'globalNotificationMessage',
      'globalNotificationType',
    ]),
  },
}
</script>

<style lang="scss" scoped>
.alert {
  font-size: 0.8rem;
}

.error-enter,
.error-leave-to {
  opacity: 0;
  box-shadow: none;
}

.error-enter-active,
.error-leave-active {
  transition: all 0.2s;
}

.error-alert {
  position: absolute;
  max-width: 500px;
  left: 50%;
  top: 5px;
  transform: translateX(-50%);
  z-index: 300;
}

.alert {
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.2);
}
</style>
